import { NavLink, Outlet } from "react-router-dom";
import { ShieldAlert, Building2, Users, BarChart3, ScrollText } from "lucide-react";

const TABS = [
  { to: "/app/platform/tenants", label: "Workspaces", icon: Building2, testid: "platform-tab-tenants" },
  { to: "/app/platform/admins", label: "Admins", icon: Users, testid: "platform-tab-admins" },
  { to: "/app/platform/stats", label: "Stats", icon: BarChart3, testid: "platform-tab-stats" },
  { to: "/app/platform/impersonation-log", label: "View-as history", icon: ScrollText, testid: "platform-tab-log" },
];

export default function PlatformShell() {
  return (
    <div className="space-y-6" data-testid="platform-shell">
      <div>
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-secondary">
          <ShieldAlert className="h-3.5 w-3.5" /> Platform admin
        </div>
        <h1 className="mt-1 font-display text-3xl font-semibold text-primary">Quanta platform</h1>
        <p className="mt-2 max-w-3xl text-muted-foreground">
          Workspace-wide surface reserved for platform admins. Grants,
          revocations, new workspaces, activity rollups, and every view-as
          event show up here.
        </p>
      </div>
      <nav className="flex flex-wrap gap-1 border-b border-border pb-2">
        {TABS.map((t) => (
          <NavLink
            key={t.to} to={t.to}
            className={({ isActive }) =>
              `flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm transition ${
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "text-muted-foreground hover:bg-accent"
              }`
            }
            data-testid={t.testid}
          >
            <t.icon className="h-3.5 w-3.5" /> {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
